<template>
  <div class="main-content">

    <!-- Section: inner-header -->
    <section class="inner-header divider parallax layer-overlay overlay-dark-5 pt-100 bg-image-100-size" data-parallax-ratio="0.7" data-bg-img="images/202208/Sarah94.jpg">
      <div class="container pt-100 pb-30">
        <div class="section-content pt-100">
          <div class="row">
            <div class="col-md-12">
              <h3 class="title text-white">Login</h3>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="loginForm">
      <div class="container pl-50 pr-50">
        <div class="row">
          <div class="col-md-8 col-md-offset-2">
            <h2 class="text-uppercase mt-0 letter-space-3 text-center font-22 mb-20">Accedi ed inizia subito l'<span class="text-theme-colored">allenamento</span></h2>
            <form @submit="clickLogin">
              <div class="row">
                <div class="form-group col-md-12">
                  <label>Email</label>
                  <input type="text" v-model="login.email" class="form-control" />
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-12">
                  <label>Password</label>
                  <input type="password" v-model="login.password" class="form-control" />
                </div>
              </div>
              <div class="form-group text-center pt-10">
                <button type="submit" class="btn btn-dark pl-50 pr-50 bg-theme-colored text-white">Accedi</button>

                <p class="mt-20">
                <a
              class="text-theme-colored text-underline"
              href="/resetpass"
              >Hai dimenticato la password?</a
            >
          </p>
                <p v-if="loginFailed" class="text-theme-colored font-12 font-weight-400 pt-10">Login non riuscito! Ricontrolla le tue credenziali.</p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- REGISTER (Da rimuovere in futuro) -->
    <section id="registerForm" class="hidden">
      <div class="container">
        <div class="heading-line-bottom">
          <h4 class="heading-title">Don't have an Account? Register Now</h4>
        </div>
        <form @submit="clickRegister">
          <div class="row">
            <div class="form-group col-md-6">
              <label>Name</label>
              <input type="text" v-model="register.name" class="form-control" />
            </div>
            <div class="form-group col-md-6">
              <label>Surname</label>
              <input type="text" v-model="register.surname" class="form-control" />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label>Email Address</label>
              <input type="email" v-model="register.email" class="form-control" />
            </div>
          </div>
          <div class="form-group">
            <button type="submit" class="btn btn-default">Register Now</button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

          
<script>
import axios from "axios";
import store from '../helper/store' // your vuex store 

function generatePassword() {
  var length = 10,
    charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
    retVal = "";
  for (var i = 0, n = charset.length; i < length; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
}

export default {
  name: "Login",
  data() {
    return {
      login: {
        email: "",
        password: ""
      },
      register: {
        email: "",
        name: "",
        surname: ""
      },
      loginFailed: false
    };
  },
  methods: {
    clickLogin: function(e) {
      
        e.preventDefault();
      if (this.login.email != "" && this.login.password != "") {

        const objForLogin =
        {
            identifier: this.login.email.toLowerCase().trim(),
            password: this.login.password
        }

        store.dispatch('login', objForLogin)
          .then(() => {
            //REDIRECT TO DASHBOARD
            window.location.replace("/dashboard");
          })
          .catch(err => {
            this.loginFailed = true;
            console.log(err);
          });
        
      }
    },
    clickRegister: function(e) {
      if (
        this.register.email != "" &&
        this.register.name != "" &&
        this.register.surname != ""
      ) {
        var password = generatePassword();

        var obj = {
          Password: password,
          Email: this.register.email
        };

        axios.post(process.env.VUE_APP_API_URL + "/User/signup", obj).then(response => {
          console.log(response.data);
          if (response.data.ok) {
            axios
              .post(process.env.VUE_APP_API_URL + "/auth/local/register", {
                username: this.register.email,
                email: this.register.email,
                password: password,
                Name: this.register.name,
                Surname: this.register.surname
              })
              .then((response) => {
                console.log("Well done!", response);
              })
              .catch(error => {
                // Handle error.
                console.log("An error occurred:", error);
              });
          }
        });

        e.preventDefault();
      }
    }
  }
};
</script>